/** Base path espace personnel d'administration (routes imbriquées sous Layout). */

export const AP_BASE = '/admin-personnel';

export const AP_PATHS = {
  DASHBOARD: AP_BASE,
  COMPANIES: `${AP_BASE}/companies`,
  MEMBERS: `${AP_BASE}/users`,
  PRICING: `${AP_BASE}/pricing`,
  INVOICES: `${AP_BASE}/invoices`,
  PROFILE: `${AP_BASE}/profile`,
  SETTINGS: `${AP_BASE}/settings`,
  REPORTS: `${AP_BASE}/reports`,
  ACTIVITIES: `${AP_BASE}/activities`,
  NOTIFICATIONS: `${AP_BASE}/notifications`
};

/** Menu latéral (ordre d’affichage) · aligné flux métier comme réception / infirmerie. */
export const AP_NAV_ITEMS = [
  {
    id: 'dashboard',
    to: AP_PATHS.DASHBOARD,
    end: true,
    label: 'Tableau de bord',
    hint: 'Synthèse & activité',
    icon: 'home'
  },
  {
    id: 'companies',
    to: AP_PATHS.COMPANIES,
    end: false,
    label: 'Sociétés partenaires',
    hint: 'Référentiel entreprises',
    icon: 'building'
  },
  {
    id: 'users',
    to: AP_PATHS.MEMBERS,
    end: false,
    label: 'Adhérents',
    hint: 'Agents & ayants-droit',
    icon: 'users'
  },
  {
    id: 'pricing',
    to: AP_PATHS.PRICING,
    end: false,
    label: 'Tarification',
    hint: 'Prix des actes SMIE',
    icon: 'chartBar'
  },
  {
    id: 'invoices',
    to: AP_PATHS.INVOICES,
    end: false,
    label: 'Facturation',
    hint: 'Soins et prises en charge',
    icon: 'clipboard-list'
  },
  {
    id: 'notifications',
    to: AP_PATHS.NOTIFICATIONS,
    end: false,
    label: 'Notifications',
    hint: 'Alertes & suivi',
    icon: 'bell',
    showUnreadBadge: true
  },
  {
    id: 'activities',
    to: AP_PATHS.ACTIVITIES,
    end: false,
    label: 'Activités',
    hint: 'Journal des actions',
    icon: 'history'
  }
];
